import type { OrganizationDto } from '@/types/dtos/organizations/organization.dto.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { type PatchOrganizationDto } from '@/types/dtos/organizations/request/patch-organization.dto.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_ORGANIZATIONS_QUERY_KEY } from '@/state/queries/organizations/use-get-organizations';
import { GET_ORGANIZATION_QUERY_KEY } from '@/state/queries/organizations/use-get-organization';

export const useEditOrganizationMutation = () => {
  const { getToken } = useAuth();

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: PatchOrganizationDto }) => {
      const token = await getToken();
      return await editOrganization({ id, data, token: token ?? '' });
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_ORGANIZATIONS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_ORGANIZATION_QUERY_KEY],
        }),
      ]);
    },
  });
};

const editOrganization = async ({
  id,
  data,
  token,
}: {
  id: string;
  data: PatchOrganizationDto;
  token: string;
}): Promise<OrganizationDto> => {
  const url = `${import.meta.env.VITE_API_URL}/organizations/${id}`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: data, token });
};
